module.exports = __webpack_public_path__ + "img/content-02.d366652c.png";